import React from 'react';
import { DraggableTooltipContainer } from 'spw-components/worksheet/styles';
import { TooltipTitle, TooltipSection, TooltipText } from './styles';

const HeadcountUtilizationGuide: React.FC = () => (
  <DraggableTooltipContainer>
    <TooltipTitle id="draggable-dialog-title" className="title">
      Headcount Utilization Tips
    </TooltipTitle>
    <div className="content">
      <TooltipText>
        What percentage of people (headcount) will go into the office each week?
      </TooltipText>
      <TooltipSection>High</TooltipSection>
      <TooltipText>70 - 100%</TooltipText>
      <TooltipText>4 - 5 days per week in the office</TooltipText>

      <TooltipSection>Medium</TooltipSection>
      <TooltipText>30 - 69%</TooltipText>
      <TooltipText>2 - 3 days per week in the office</TooltipText>

      <TooltipSection>Low</TooltipSection>
      <TooltipText>0 - 29%</TooltipText>
      <TooltipText>0 - 1 days per week in the office</TooltipText>
    </div>
  </DraggableTooltipContainer>
);

export default HeadcountUtilizationGuide;
